import { z } from "zod";

export const taskFormSchema = z.object({
  title: z.string().min(1, "Title is required"),
  description: z.string().optional(),
  completed: z.boolean().default(false),
  category: z.string().default("Uncategorized"),
  priority: z.enum(["low", "medium", "high", "urgent"]).default("medium"),
  tags: z.array(z.string()).default([]),
  assignedTo: z.string().default("Me"),
  assignedToOther: z.string().optional(),
  columnId: z.string().optional(),
  assignedToUserId: z.string().optional(),
  dueDate: z.string().optional(),
  linkType: z.enum(["none", "goal", "milestone", "journal"]).default("none"),
  goalId: z.string().optional(),
  milestoneId: z.string().optional(),
  journalEntryId: z.string().optional(),
  checklistId: z.string().nullable().optional(),
  selectedGoalId: z.string().optional(),
  isTopThree: z.boolean().default(false),
  showOnMainTaskPage: z.boolean().default(true),
  isRecurring: z.boolean().default(false),
  recurrenceFrequency: z.string().optional(),
  recurrenceEndDate: z.string().optional(),
  recurrenceCount: z.number().int().optional(),
  recurrenceParentId: z.string().optional(),
  isMasterRecurringTask: z.boolean().default(false),
  isRecurringInstance: z.boolean().default(false),
});

export type TaskFormInput = z.input<typeof taskFormSchema>;
export type TaskFormData = z.output<typeof taskFormSchema>;
